import { render, staticRenderFns } from "./newList.vue?vue&type=template&id=22681458&scoped=true&"
import script from "./newList.vue?vue&type=script&lang=js&"
export * from "./newList.vue?vue&type=script&lang=js&"
import style0 from "./newList.vue?vue&type=style&index=0&id=22681458&scoped=true&lang=css&"
import style1 from "./newList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22681458",
  null
  
)

export default component.exports